//angular.module('app').factory('SettingsService', function (HttpHelper) {
angular.module('app').factory('SettingsService', function (HttpHelper, $http, $q) {

    var appSettings = null;
    var fac = {
        getSettings: getSettings,
        getCachedSettings: getCachedSettings
    };

    // Get appSettings from http or cache
    function getCachedSettings() {
        var deferred = $q.defer();
        if (appSettings !== null) {
            deferred.resolve(appSettings);
            return deferred.promise;
        }
        return $http({
            method: 'GET',
            url: 'api/App/Settings',
            cache: true
        }).then(function (response) {
            appSettings = response.data;
            return appSettings;
        });
    }
    function getSettings() {
        return HttpHelper.get('api/App/Settings');
    }
    return fac;
});
//# sourceMappingURL=settings.service.js.map